<template>
  <!-- 智能鉴宝 -->
  <div class="page-collect-search-photo">
    <div class="g-content-wrap">
      <div class="sch-box">
        <!-- <el-upload ref="myUpload"
          class="upload-demo"
          action="#"
          list-type="picture-card"
          :limit="1"
          :auto-upload="false">
            <div slot="default" class="btn-upload" @click="fileList=[]"></div>
            <div slot="file" slot-scope="{file}">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url" alt=""
              >
            </div>
        </el-upload> -->

        <el-upload style="z-index: 2;"
          ref="myUpload"
          class="upload-demo"
          action="/admin/search/searchPicture.do"
          :data="configData"
          :file-list="fileList"
          :limit="1"
          :auto-upload="false"
          list-type="picture"
          :on-success="handleAvatarSuccess">
          <div class="btn-upload" @click="handleClick"></div>
        </el-upload>

        <!-- <cmpUploadMainPhonto
          :callFun="getPhotoList"
          :fileList="pictureList"
          :showUpload="true"
          :showMainBtn="false"
          :multipleType="false"
          :showName="false"
        ></cmpUploadMainPhonto> -->
        <!-- <img class="upload-pic" src="http://files.tjcmps.com/collection/12/01/03/21800091/10034410/THUMB/640x4261201032180009110034410-a-0002.jpg" alt=""> -->

        <a class="btn-digital g-btn-level-1 mt-10" @click="handleSearch" style="z-index: 2;">智能鉴宝</a>
      </div>

      <div v-show="showRes">
        <div class="g-line"></div>

        <p class="res tc mt-20 mb-40">找到{{dataList.length}}条相似结果</p>

        <div class="list g-card-list">
          <div class="item g-card-1" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
            <div class="pic-box">
              <img v-lazy="item.url" alt="">
              <div class="tag-box">
                <span class="tag">{{item.year}}</span>
                <span class="tag">{{item.type}}</span>
              </div>
            </div>
            <div class="info">
              <h2>{{item.name}}</h2>
              <p>{{item.museumName}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import cmpUploadMainPhonto from '@cmp/my-upload/main-photo'
export default {
  // components: { cmpUploadMainPhonto },
  data() {
    return {
      configData: {
        userId: this.$store.state.user.userid,
        token: this.$store.state.user.token,
      },
      fileList: [],
      // pictureList: [
      //   {
      //     attPath: 'http://files.tjcmps.com/collection/12/01/03/21800091/10034410/THUMB/640x4261201032180009110034410-a-0002.jpg'
      //   },
      // ],
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 10,
      },
      total: 0,
      showRes: false
    }
  },
  methods: {
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    getPhotoList() {

    },
    handleClick() {
      this.showRes = false
      this.fileList = []
    },
    handleSearch() {
      if(!this.$refs.myUpload.uploadFiles || !this.$refs.myUpload.uploadFiles.length) {
        this.$message.warning('请先添加图片')
        return
      }
      this.$refs.myUpload.submit()
    },
    handleAvatarSuccess(res) {
      this.showRes = true
      if (res.success) {
        this.dataList = res.data.collect
      } else {
        this.$message.error(res.message)
      }
    },
    goDetail(item) {
      this.$router.push({
        path: '/collect/detail',
        query: {id: item.id}
      })
    }
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
.page-collect-search-photo {
  // .upload-demo {
  //   /deep/ .el-upload--picture-card {
  //     width: auto;
  //     height: auto;
  //   }
  // }
  .upload-demo {
    .btn-upload {
      position: relative;
      z-index: 3;
      width: 408px;
      height: 212px;
      background: url(~@images/upload-add-2.png) no-repeat center center;
      background-size: 100% 100%;
    }
    /deep/ .el-upload-list {
      position: absolute;
      left: 15px;
      top: 15px;
      width: calc(100% - 30px);
      height: calc(100% - 30px);
      padding: 0;
      .el-upload-list__item-name {
        display: none;
      }
      .el-icon-close {
        display: none;
      }
      .el-upload-list__item {
        padding: 0;
        margin-top: 0;
        margin-bottom: 10px;
        border-radius: 0;
        // width: 120px;
        // height: 80px;
        width: 100%;
        height: 100%;
        border: none;
        background: transparent;
        .el-upload-list__item-thumbnail {
          float: none;
          margin: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .sch-box {
    position: relative;
    margin-bottom: 40px;
    height: 400px;
    background: url(~@images/sch-bg.png) no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .upload-pic {
      position: absolute;
      left: 15px;
      top: 15px;
      width: calc(100% - 30px);
      height: calc(100% - 30px);
    }
  }

  .res {
    font-size: 16px;
    color: #999493;
  }

  /deep/ .cmp-main-photo {
    position: relative;
    z-index: 2;
    .uploader .uploader-btn {
      width: 408px;
      height: 212px;
      background: url(~@images/upload-add-2.png) no-repeat center center;
      background-size: 100% 100%;
    }
  }
}
</style>

